import { render, staticRenderFns } from "./hold.vue?vue&type=template&id=343d7ab4&scoped=true"
import script from "./hold.vue?vue&type=script&lang=js"
export * from "./hold.vue?vue&type=script&lang=js"
import style0 from "./hold.vue?vue&type=style&index=0&id=343d7ab4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343d7ab4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('343d7ab4')) {
      api.createRecord('343d7ab4', component.options)
    } else {
      api.reload('343d7ab4', component.options)
    }
    module.hot.accept("./hold.vue?vue&type=template&id=343d7ab4&scoped=true", function () {
      api.rerender('343d7ab4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/users/competition/hold.vue"
export default component.exports